import React, { useMemo } from 'react'
import { FormProvider, useForm, useWatch } from 'react-hook-form'
import { toast } from 'react-toastify'

import {
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { Select } from '@/components/Form'

// Logic

import { OfferType } from '@/features/offers/constants'
import { camelToWords } from '@/utils/stringHelper'
//Slice
import { useCostCenter } from '@/features/costCenters/useCostCenter'
import { useAddSubSystemModalManagement } from '@/stores/offers/offersSlice'
import { createOptions } from '@/utils/arrayHelper'

const AddSubSystemModal = () => {
  const { isOpened, submit, close } = useAddSubSystemModalManagement()

  // Hook
  const { useCostCenterOptions, useFetchAllCostCenters } = useCostCenter()

  const methods = useForm()

  //Translated Variables
  const { data: costCenterResponse } = useFetchAllCostCenters({ page: 1, pageSize: 0, filters: { status: 'active' } })

  const subSystemType = useWatch({ name: 'subSystemType', control: methods.control })

  const costCenterOptions = useMemo(() => {
    if (!Array.isArray(costCenterResponse?.data)) {
      return []
    }

    const filteredCostCenters = costCenterResponse.data.filter((costCenter) => costCenter.type === subSystemType)

    return createOptions(
      filteredCostCenters,
      (costCenter) => `${costCenter.profitCenterCode || ''} - ${costCenter.name || ''}`,
      '_id'
    )
  }, [subSystemType, costCenterResponse?.data])

  const closeModal = () => {
    methods.reset({
      subSystemType: '',
      profitCenterId: '',
    })
    close()
  }

  const onSubmit = ({ subSystemType, profitCenterId }) => {
    if (!subSystemType || !profitCenterId) {
      toast.error('Missing Type / Profit Center')
      return
    }

    const selectedProfitCenter = costCenterResponse?.data.find((profitCenter) => profitCenter?._id === profitCenterId)
    if (!selectedProfitCenter) {
      toast.error('[Sever Error] Missing selected profit center')
      return
    }
    submit({
      subSystemType: subSystemType,
      profitCenterId: profitCenterId,
      subSystemName: selectedProfitCenter?.description ?? '',
    })

    methods.reset({
      subSystemType: '',
      profitCenterId: '',
    })
  }

  return (
    <Modal isOpen={isOpened} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW="30%">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalHeader>Add Subsystem</ModalHeader>

            <ModalCloseButton />
            <ModalBody>
              <Flex gap={3} direction={'column'}>
                <Select
                  name="subSystemType"
                  label="Type "
                  isRow
                  options={[
                    {
                      value: OfferType.MAINTENANCE,
                      label: camelToWords(OfferType.MAINTENANCE),
                    },
                    {
                      value: OfferType.PROJECT,
                      label: camelToWords(OfferType.PROJECT),
                    },
                  ]}
                />
                <Select name="profitCenterId" label="Profit Center" options={costCenterOptions} isRow />
              </Flex>
            </ModalBody>

            <ModalFooter>
              <HStack>
                <Button colorScheme="green" type="submit">
                  Confirm
                </Button>

                <Button colorScheme="gray" onClick={closeModal}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default AddSubSystemModal
